import React, {useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Loader from "react-loader-spinner";
import Initiative from "./initiative/initiative";
import InitiativeForm1 from "./initiative/initiativeForm1";
import InitiativeForm2 from "./initiative/initiativeForm2";
import GalleryForm from "./initiative/galleryForm";
import Login from "../components/login/login";
import Menu from "./../components/menu/menu";
import {useSelector} from 'react-redux';
import './../assets/styles/styles.css';

function RouterApp(){

  const user = useSelector(state => state.user);
  const global = useSelector(state => state.global);
  const [routesConfig, updateRoutesConfig] = useState({
    stackInitiative:{
      activeRoute:"/iniciativa"
    }
  });

  const changeRouter = (keyName, activeRoute) => {
    if(routesConfig[keyName].activeRoute !== activeRoute){
      updateRoutesConfig({
        ...routesConfig,
        [keyName]:{
          activeRoute:activeRoute
        }
      });
    }
  }

  return(
    <div className="h-100" id="router" style={{overflow:"auto", fontFamily:"sans-serif"}}>
        <div className="fixedBackground" style={{zIndex:9999, display: global.queryIsLoading? "flex": "none"}}>
          <Loader type="Oval" color="#0f8238b8" height={100} width={100} visible={true}/>
        </div>
      {
        /*user.auth === false || user.auth === undefined?
        <Login/> : */
        <Router>
          <Menu/>
          <Switch>
            <Route path="/" exact render={() => {
              changeRouter("stackInitiative", "/iniciativa");
              return <Initiative/>
            }}/>
            <Route path="/iniciativa" exact render={() => {
              changeRouter("stackInitiative", "/iniciativa");
              return <Initiative/>
            }}/>
            <Route path="/iniciativa/formulario1/" exact render={() => {
              changeRouter("stackInitiative", "/formulario1");
              return <InitiativeForm1/>
            }}/>
            <Route path="/iniciativa/formulario1/galeria" exact render={() => {
              changeRouter("stackInitiative", "/galeria");
              return <GalleryForm/>
            }}/>
            <Route path="/iniciativa/formulario1/formulario2/" exact render={() => {
              changeRouter("stackInitiative", "/formulario2");
              return <InitiativeForm2/>
            }}/>
          </Switch>
        </Router>
      }
    </div>
  );
}

export default RouterApp;
